import { getEmptySelectionSet } from './getEmptySelectionSet';

export const getEmptySelectionSets = (): SelectionSets => ({
    international: getEmptySelectionSet(),
    standard: getEmptySelectionSet(),
    unfiltered: getEmptySelectionSet(),
});
